import React, { useEffect, useRef, useState } from "react";
import { Icons } from "../../../config/MuiIcons.config";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Chip,
  Divider,
  Grid2,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import { Link, useNavigate, useParams } from "react-router-dom";
import ViewIcon from "../../../assets/images/View.svg";
import DeleteIcon from "../../../assets/images/Delete.svg";
import {
  APP_MESSAGE,
  ERROR_MESSAGE,
  FORM_VALIDATIONS,
  SNACKBAR_VARIANT,
  USE_FORMIK_SCHEMA,
} from "../../../config/Messages.config";
import AppInputField from "../../../components/CommonReusableComponent/AppInputField/AppInputField";
import MUIDatePicker from "../../../components/MUIDatePicker/MUIDatePicker";
import MUIErrorText from "../../../components/MUIErrorText/MUIErrorText";
import AppButton from "../../../components/CommonReusableComponent/AppButton/AppButton";
import { getUserRoleAndScreens } from "../../../services/authServices/auth.services";
import {
  getAllDepartmentListByBranchId,
  getAreasByBranchAndDept,
  getListOfAuditType,
  createNewThirdPartyAudit,
  updateExistingThirdPartyAudit,
  updateStatusOfThirdPartyAuditToCompleted,
  getListOfAuditTypeCategories,
} from "../../../helpers/api-functions-helper";
import { useBackdrop } from "../../../contexts/BackDrop.context";
import { useSnackbar } from "../../../contexts/Snackbar.context";
import {
  addCurrentTimeInTimeStamp,
  generateRandomId,
  getFileNameFromInput,
  setRequiredDataForDropdown,
} from "../../../common/CommonFunctions";
import {
  dataTableColumnsForNCActivitiesOfThirdPartyAudits,
  getStatusChipDetailsForThirdPartyAudits,
  // getRemarkChipDetailsForThirdPartyAudits,
  RemarkText,
  ThirdPartyAuditInfo,
} from "./ThirdPartyAuditMaster.config";
import { ROLES } from "../../../config/Roles.config";
import { thirdPartyStatusConfigData, thirdPartyRemarkConfigData } from "../../../config/AuditStatusConfig";
import AppAutoCompleteField from "../../../components/CommonReusableComponent/AppAutoCompleteField/AppAutoCompleteField";
import { uploadMultipleFilesInFirebase } from "../../../common/UploadMultipleFilesToFirebaseBucket/UploadMultipleFilesToFirebaseBucket";
import { CLOUD_STOAGE } from "../../../config/CloudStorage.config";
import { AppTheme } from "../../../theme/App.theme";
import DataTableToUpdateNCActivityOfThirdPartyAudit from "./DataTableToUpdateNCActivityOfThirdPartyAudit";
import WarningModalForThirdPartyFinalSave from "./WarningModalForThirdPartyFinalSave";
import ThirdPartyRemarksAndReasonModal from "./ThirdPartyRemarkAndRessonModal";

const CreateNewOrUpdateThirdPartyAudit = () => {
  const navigate = useNavigate();
  const params = useParams();
  const lastSubmitCountRef = useRef(0);
  const isMobileDevice = useMediaQuery("(max-width:599px)");
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const { showSnackbar } = useSnackbar();
  const { assignedBranches, accountId, role, userUid } =
    getUserRoleAndScreens();

  const { completed, draftAudits, reviewPending } = thirdPartyStatusConfigData;

  // Form mode
  const isViewMode = document.location.pathname.includes("/view");
  const isCreateMode = document.location.pathname.includes("/create");
  const isUpdateMode = document.location.pathname.includes("/update");

  // User type
  const isSuperAdmin =
    role && role.toLowerCase() === ROLES.SUPERADMIN ? true : false;

  const isAdmin = role && role.toLowerCase() === ROLES.ADMIN ? true : false;

  const isUser = role && role.toLowerCase() === ROLES.USER ? true : false;

  // All the selection states/dropdown
  const [auditTypeCategories, setAuditTypeCategories] = useState([]);
  const [auditTypes, setAuditTypes] = useState([]);
  const [branches, setBranches] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [areas, setAreas] = useState([]);

  // Global Audit Type List
  const [allAuditTypes, setAllAuditTypes] = useState([]);

  // NC Activity Data Table
  const [NCActivityDataTable, setNCActivityDataTable] = useState([]);

  // Global state to store the third party audit details
  const [
    thirdPartyAuditdataByLocalStorage,
    setThirdPartyAuditdataByLocalStorage,
  ] = useState(null);

  // loading states
  const [loadingState, setLoadingState] = useState({
    auditTypeCategory: false,
    auditTypes: false,
    departments: false,
    areas: false,
    createThirdPartyAudit: false,
    updateThirdPartyAudit: false,
    updateStatusOfThirdPartyAudit: false,
    auditReportURLUpload: false,
    attachmentsUpload: false,
  });

  // State to manage accordion components
  const [accordionState, setAccordionState] = useState({
    basicAuditDetails: true,
    auditorDetails: true,
  });

  // Add/Update NC Activity Modal
  const [addOrUpdateNCActivityModal, setAddOrUpdateNCActivityModal] = useState({
    isOpen: false,
    data: null,
    type: null,
  });

  // Audit Report File State
  const [auditReportImageURL, setAuditReportImageURL] = useState({
    url: null,
    file: null,
    name: "",
  });

  // Warning Modal for final save
  const [finalSaveModalState, setFinalSaveModalState] = useState({
    isOpen: false,
    data: null,
    type: "",
  })

  const [sendBackToAuditeeModal, setSendBackToAuditeeModal] = useState({
    isOpen: false,
    apiPayload: null,
  })

  // Function to update loading state
  const setLoading = (key, value) => {
    setLoadingState((prev) => {
      return { ...prev, [key]: value };
    });
  };

  // Handle the Add/Update NC Activity Modal
  const handleToggleNCActivityModal = (
    Data = null,
    IsOpen = false,
    Type = null
  ) => {
    setAddOrUpdateNCActivityModal((prev) => ({
      ...prev,
      data: Data,
      isOpen: IsOpen,
      type: Type,
    }));
  };

  // Function to handle toggle for accordion
  const toggleAccordion = (accordionKey) => {
    setAccordionState((prevState) => ({
      ...prevState,
      [accordionKey]: !prevState[accordionKey], // Toggle only the selected accordion
    }));
  };

  // Function to handle toggle of warning modal for submit
  const handleFinalSaveWarning = (isOpen = false, data = null, type = "") => {
    setFinalSaveModalState((prev) => ({
      ...prev,
      isOpen: isOpen,
      data: data,
      type: type
    }))
  }

  // Function to handle toggle of send back to auditee modal
  const handleToggleOfSendBackToAditeeModal = (isOpen = false, apiPayload = null) => {
    setSendBackToAuditeeModal((prev) => ({
      ...prev,
      isOpen: isOpen,
      apiPayload: apiPayload
    }))
  }

  // ------------------------- UTILITY FUNCTIONS -------------------------
  // Reusable function to set state values
  const setDropdownState = (setter, label, value) => {
    if (label && value) {
      setter([{ label, value }]);
    } else {
      setter([]); // Set empty array if data is missing
    }
  };

  // Function to handle change for audit related things
  const getDataAsPerRequirement = (value, data, key) => {
    if (data && data[0]) {
      const selectedObj = data.find((item) => item.value === value);
      return selectedObj
        ? {
            [`${key}Id`]: selectedObj.value,
            [`${key}Name`]: selectedObj.label,
          }
        : null;
    }

    return null;
  };

  // Accordion style  
  const accordionStyle = {
    borderRadius: "8px",
    boxShadow: "0 0 8px rgba(93, 101, 108, 0.3)",
    transition: "all 0.5s ease",
  };
  const accordionHeaderStyle = {
    borderRadius: "8px 8px 0 0",
    fontWeight: "bold",
  };

  useEffect(() => {
    const thirdPartyAuditDetails = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_DEV_THIRD_PARTY_AUDIT_DATA)
    );

    if (thirdPartyAuditDetails) {
      setThirdPartyAuditdataByLocalStorage({ ...thirdPartyAuditDetails });
    }
  }, []);

  // Fetch all active branches
  const fetchAllBranches = () => {
    setRequiredDataForDropdown(setBranches, assignedBranches, "name", "id");
  };

  // Fetch all audit type categories
  const fetchAllAuditTypeCategories = async () => {
    try {
      setLoading("auditTypeCategory", true);
      const categoryRes = await getListOfAuditTypeCategories(accountId);

      if (!categoryRes?.data) {
        throw new Error("Failed to fetch audit type categories");
      }

      const { statusCode, data } = categoryRes.data;

      if (statusCode !== 200 || !data) {
        setAuditTypeCategories([]);
        throw new Error(ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      }

      setRequiredDataForDropdown(setAuditTypeCategories, data, "name", "id");
    } catch (error) {
      console.log("Error: ", error);
      showSnackbar(ERROR_MESSAGE.FAILED_TO_FETCH_DATA, SNACKBAR_VARIANT.ERROR);
    } finally {
      setLoading("auditTypeCategory", false);
    }
  };

  // Function to fetch all audit types
  const fetchAllAuditTypes = async () => {
    try {
      setLoading("auditTypes", true);
      const response = await getListOfAuditType(accountId);

      if (!response?.data) {
        throw new Error("Failed to fetch audit types");
      }

      const { statusCode, data, success } = response.data;

      if (!success || statusCode !== 200 || !data) {
        setAuditTypes([]);
        setAllAuditTypes([]);
        throw new Error(ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      }

      setAllAuditTypes(data);
      setRequiredDataForDropdown(setAuditTypes, data, "name", "id");
    } catch (error) {
      console.error("Error in fetchAllAuditTypes:", error);
      showSnackbar(
        error.message || ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
        SNACKBAR_VARIANT.ERROR
      );
    } finally {
      setLoading("auditTypes", false);
    }
  };

  // Function to fetch all departments by branch id
  const fetchAllDepartmentByBranchId = async (branchId) => {
    try {
      setLoading("departments", true);

      const payload = {
        branchIds: [branchId],
        accountId: accountId,
      };

      const response = await getAllDepartmentListByBranchId(payload);

      if (!response?.data) {
        throw new Error("Failed to fetch departments");
      }

      const { statusCode, data } = response.data;

      if (statusCode !== 200 || !data) {
        setDepartments([]);
        throw new Error(ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      }

      setRequiredDataForDropdown(setDepartments, data, "name", "id");
    } catch (error) {
      console.error("Error in fetchAllDepartmentByBranchId:", error);
      showSnackbar(
        error.message || ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
        SNACKBAR_VARIANT.ERROR
      );
    } finally {
      setLoading("departments", false);
    }
  };

  // Function to fetch areas by brand & department ID
  const fetchAllAreaByDepartmentIdAndBranchId = async (
    branchId,
    departmentId
  ) => {
    try {
      setLoading("areas", true);

      const payload = {
        accountId: accountId,
        branchIds: [branchId],
        departmentIds: [departmentId],
      };

      const response = await getAreasByBranchAndDept(payload);

      if (!response?.data) {
        throw new Error("Failed to fetch areas.");
      }

      const { statusCode, data } = response.data;

      if (statusCode !== 200 || !data) {
        setAreas([]);
        throw new Error(ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      }

      setRequiredDataForDropdown(setAreas, data, "name", "id");
    } catch (error) {
      console.error("Error in fetchAllAreaByDepartmentIdAndBranchId:", error);
      showSnackbar(
        error.message || ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
        SNACKBAR_VARIANT.ERROR
      );
    } finally {
      setLoading("areas", false);
    }
  };

  // Create new third-party audit
  const thirdPartyAuditCreation = async (DATA) => {
    try {
      setLoading("createThirdPartyAudit", true);
      const response = await createNewThirdPartyAudit(DATA);

      if (!response?.data) {
        throw new Error("Failed to create third party audit.");
      }

      const { statusCode, success, data, message } = response.data;

      if (!success || statusCode !== 200) {
        throw new Error(
          data || message || APP_MESSAGE.THIRD_PARTY_AUDIT_MASTER.CREATE.FAILED
        );
      }

      showSnackbar(
        APP_MESSAGE.THIRD_PARTY_AUDIT_MASTER.CREATE.SUCCESS,
        SNACKBAR_VARIANT.SUCCESS
      );
      navigate(-1);
    } catch (error) {
      console.error("Error in createThirdPartyAudit:", error);
      showSnackbar(
        error.message || APP_MESSAGE.THIRD_PARTY_AUDIT_MASTER.CREATE.FAILED,
        SNACKBAR_VARIANT.ERROR
      );
    } finally {
      setLoading("createThirdPartyAudit", false);
    }
  };

  // Create new third-party audit
  const thirdPartyAuditUpdation = async (DATA) => {
    try {
      setLoading("updateThirdPartyAudit", true);
      const response = await updateExistingThirdPartyAudit(DATA);

      if (!response?.data) {
        throw new Error("Failed to update third party audit.");
      }

      const { statusCode, success, data, message } = response.data;

      if (!success || statusCode !== 200) {
        throw new Error(
          data || message || APP_MESSAGE.THIRD_PARTY_AUDIT_MASTER.UPDATE.FAILED
        );
      }

      showSnackbar(
        APP_MESSAGE.THIRD_PARTY_AUDIT_MASTER.UPDATE.SUCCESS,
        SNACKBAR_VARIANT.SUCCESS
      );
      localStorage.removeItem(process.env.REACT_APP_DEV_THIRD_PARTY_AUDIT_DATA);
      navigate(-1);
    } catch (error) {
      console.error("Error in updateThirdPartyAudit:", error);
      showSnackbar(
        error.message || APP_MESSAGE.THIRD_PARTY_AUDIT_MASTER.UPDATE.FAILED,
        SNACKBAR_VARIANT.ERROR
      );
    } finally {
      setLoading("updateThirdPartyAudit", false);
    }
  };

  // Update/Review Audit for Auditor
  const updateThirdPartyAuditStatus = async (DATA) => {
    try {
      setLoading("updateStatusOfThirdPartyAudit", true);
      const response = await updateStatusOfThirdPartyAuditToCompleted(DATA);

      if (!response?.data) {
        throw new Error("Failed to update third party audit.");
      }

      const { statusCode, success, data, message } = response.data;

      if (!success || statusCode !== 200) {
        throw new Error(
          data || message || APP_MESSAGE.THIRD_PARTY_AUDIT_MASTER.UPDATE.FAILED
        );
      }

      showSnackbar(
        APP_MESSAGE.THIRD_PARTY_AUDIT_MASTER.UPDATE.SUCCESS,
        SNACKBAR_VARIANT.SUCCESS
      );
      localStorage.removeItem(process.env.REACT_APP_DEV_THIRD_PARTY_AUDIT_DATA);
      navigate(-1);
    } catch (error) {
      console.error("Error in updateOrReviewAuditForAuditor:", error);
      showSnackbar(
        error.message || APP_MESSAGE.THIRD_PARTY_AUDIT_MASTER.UPDATE.FAILED,
        SNACKBAR_VARIANT.ERROR
      );
    } finally {
      setLoading("updateStatusOfThirdPartyAudit", false);
    }
  };

  // Handle form reset
  const handleReset = () => {
    setAuditReportImageURL({
      name: "",
      url: null,
      file: null,
    });
    setNCActivityDataTable([]);
  };

  // Validate the payload
  const validateAuditPayload = (payload) => {
    const errors = [];

    // Rule 1: Total = NC + Closed
    const expectedTotal =
      payload.totalNCActivitiesCount + payload.closedActivitiesCount;
    if (payload.totalActivitiesCount !== expectedTotal) {
      errors.push(
        `Total Activities Count must equal the sum of NC Activities and Closed Activities.`
      );
    }

    // Rule 2: NC count = array length
    if (payload.totalNCActivitiesCount !== payload.ncActivities.length) {
      errors.push(
        `The number of NC Activities entered does not match the specified count.`
      );
    }

    // Rule 3: Audit Report URL should be present
    const auditFile = payload?.auditReportURL;

    const isAuditReportValid =
      (typeof auditFile === "string" && auditFile.trim().startsWith("https")) || // Already uploaded
      auditFile instanceof Blob ||
      auditFile instanceof File; // Blob waiting to upload

    if (!isAuditReportValid) {
      errors.push("Audit report file must be uploaded before submission.");
    }

    return errors;
  };

  const getNewFilesFromAttachments = (attachmentsArray) =>
    attachmentsArray.filter(
      (item) =>
        typeof item !== "string" &&
        (item instanceof File || item instanceof Blob || item.path)
    );

  // Function to upload all the documents to firebase storage-bucket
  const processAttachmentsAndAuditReport = async ({
    ncActivities = [],
    auditReportFile = null,
  }) => {
    const updatedNCActivities = [];
    let auditReportURL = "";

    // ---------- 1. Upload Audit Report ----------
    if (auditReportFile instanceof Blob || auditReportFile instanceof File) {
      await new Promise((resolve) => {
        uploadMultipleFilesInFirebase(
          CLOUD_STOAGE.THIRD_PARTY_AUDIT_REPORT_URL,
          [auditReportFile],
          (uploadedFiles) => {
            auditReportURL = uploadedFiles?.[0]?.url || "";
            resolve();
          },
          (val) => setLoading("auditReportURLUpload", val),
          ({ isError, message }) => {
            if (isError) {
              showSnackbar(message, SNACKBAR_VARIANT.ERROR);
            } else {
              showSnackbar(message, SNACKBAR_VARIANT.SUCCESS);
            }
          }
        );
      });
    } else if (typeof auditReportFile === "string") {
      auditReportURL = auditReportFile;
    }

    // ---------- 2. Upload Attachments inside Activities ----------
    for (const activity of ncActivities) {
      const newFiles = getNewFilesFromAttachments([...activity.attachments]);

      if (newFiles.length > 0) {
        await new Promise((resolve) => {
          uploadMultipleFilesInFirebase(
            CLOUD_STOAGE.THIRD_PARTY_AUDIT_ATTACHMENTS,
            newFiles,
            (uploadedFiles) => {
              const updatedAttachments = [...activity.attachments].map(
                (item) => {
                  if (typeof item === "string") return item;

                  const match = uploadedFiles.find((f) => f.name === item.name);
                  return match ? match.url : item;
                }
              );

              updatedNCActivities.push({
                ...activity,
                attachments: updatedAttachments,
              });

              resolve();
            },
            (val) => setLoading("attachmentsUpload", val),
            ({ isError, message }) => {
              if (isError) {
                showSnackbar(message, SNACKBAR_VARIANT.ERROR);
              } else {
                showSnackbar(message, SNACKBAR_VARIANT.SUCCESS);
              }
            }
          );
        });
      } else {
        updatedNCActivities.push(activity);
      }
    }

    return {
      auditReportURL,
      ncActivities: updatedNCActivities,
    };
  };

  const handleFinalSaveAfterDocumentUpload = async (DATA, ACTION) => {
    try {
      const { auditReportURL, ncActivities } = await processAttachmentsAndAuditReport({ 
        auditReportFile: DATA?.auditReportURL,
        ncActivities: DATA?.ncActivities
      });

      console.log("Uploaded data to firebase: ", auditReportURL, ncActivities);

      const finalPayload = {
        ...DATA,
        auditReportURL: auditReportURL,
        ncActivities: ncActivities?.map((item) => {
          return {
            ...item,
            attachments:
              item?.attachments?.map((doc) => doc?.file || doc) ||
              [],
          };
        }),
      };

      console.log("Final Payload for Auditee: ", finalPayload);
      if (ACTION === "CREATE") {
        thirdPartyAuditCreation(finalPayload)
      } 
      
      if (ACTION === "UPDATE") {
        thirdPartyAuditUpdation(finalPayload)
      }

    } catch (error) {
      console.error("Upload failed:", error);
      showSnackbar("Upload failed. Please try again.", SNACKBAR_VARIANT.ERROR);
    }
  }; 

  // Formik form validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      auditTypeCategoryId:
        (params?.auditId &&
          thirdPartyAuditdataByLocalStorage?.auditTypeCategoryId) ||
        "",
      auditTypeId:
        (params?.auditId && thirdPartyAuditdataByLocalStorage?.auditTypeId) ||
        "",
      branchId:
        (params?.auditId && thirdPartyAuditdataByLocalStorage?.branchId) || "",
      departmentId:
        (params?.auditId && thirdPartyAuditdataByLocalStorage?.departmentId) ||
        "",
      areaId:
        (params?.auditId && thirdPartyAuditdataByLocalStorage?.areaId) || "",
      startDate:
        (params?.auditId && thirdPartyAuditdataByLocalStorage?.startDate) || "",
      endDate:
        (params?.auditId && thirdPartyAuditdataByLocalStorage?.endDate) || "",
      totalActivitiesCount:
        (params?.auditId &&
          thirdPartyAuditdataByLocalStorage?.totalActivitiesCount) ||
        "",
      totalNCActivitiesCount:
        (params?.auditId &&
          thirdPartyAuditdataByLocalStorage?.totalNCActivitiesCount) ||
        "",
      closedActivitiesCount:
        (params?.auditId &&
          thirdPartyAuditdataByLocalStorage?.closedActivitiesCount) ||
        "",

      // Auditor Details
      auditorName:
        (params?.auditId &&
          thirdPartyAuditdataByLocalStorage?.auditorDetails?.auditorName) ||
        "",
      organizationType:
        (params?.auditId &&
          thirdPartyAuditdataByLocalStorage?.auditorDetails
            ?.organizationType) ||
        "",
      department:
        (params?.auditId &&
          thirdPartyAuditdataByLocalStorage?.auditorDetails?.department) ||
        "",
      companyName:
        (params?.auditId &&
          thirdPartyAuditdataByLocalStorage?.auditorDetails?.companyName) ||
        "",
      contactNumber:
        (params?.auditId &&
          thirdPartyAuditdataByLocalStorage?.auditorDetails?.contactNumber) ||
        "",
      email:
        (params?.auditId &&
          thirdPartyAuditdataByLocalStorage?.auditorDetails?.email) ||
        "",
      employeeId:
        (params?.auditId &&
          thirdPartyAuditdataByLocalStorage?.auditorDetails?.employeeId) ||
        "",
    },
    validationSchema: Yup.object({
      auditTypeCategoryId: Yup.string().required(
        USE_FORMIK_SCHEMA.THIRD_PARTY_AUDIT_MASTER.SELECT_AUDIT_TYPE_CATEGORY
      ),
      auditTypeId: Yup.string().required(
        USE_FORMIK_SCHEMA.THIRD_PARTY_AUDIT_MASTER.SELECT_AUDIT_TYPE
      ),
      branchId: Yup.string().required(
        USE_FORMIK_SCHEMA.THIRD_PARTY_AUDIT_MASTER.SELECT_BRANCH
      ),
      departmentId: Yup.string().required(
        USE_FORMIK_SCHEMA.THIRD_PARTY_AUDIT_MASTER.SELECT_DEPARTMENT
      ),
      areaId: Yup.string().required(
        USE_FORMIK_SCHEMA.THIRD_PARTY_AUDIT_MASTER.SELECT_AREA
      ),
      startDate: Yup.string().required(
        USE_FORMIK_SCHEMA.THIRD_PARTY_AUDIT_MASTER.SELECT_START_DATE
      ),
      endDate: Yup.string().required(
        USE_FORMIK_SCHEMA.THIRD_PARTY_AUDIT_MASTER.SELECT_END_DATE
      ),
      totalActivitiesCount: Yup.number().required(
        USE_FORMIK_SCHEMA.THIRD_PARTY_AUDIT_MASTER.ENTER_ACTIVITIES_COUNT
      ),
      totalNCActivitiesCount: Yup.number().required(
        USE_FORMIK_SCHEMA.THIRD_PARTY_AUDIT_MASTER.ENTER_NC_ACTIVITIES_COUNT
      ),
      closedActivitiesCount: Yup.number().required(
        USE_FORMIK_SCHEMA.THIRD_PARTY_AUDIT_MASTER.ENTER_CLOSED_ACTIVITIES_COUNT
      ),

      // Auditor Details
      auditorName: Yup.string().required("Enter auditor name"),
      organizationType: Yup.string(),
      department: Yup.string(),
      companyName: Yup.string().required("Enter company name"),
      contactNumber: Yup.string()
        .matches(
          FORM_VALIDATIONS.NUMBER_INPUT.REGEX,
          FORM_VALIDATIONS.NUMBER_INPUT.MESAAGE
        )
        .required("Enter contact number"),
      email: Yup.string().email("Please enter a valid email"),
      employeeId: Yup.string(),
    }),
    onSubmit: (values) => {
      // Get final activity list
      const filteredNCActivity = [...NCActivityDataTable].map(
        ({ id, ...obj }) => obj
      );

      const payload = {
        ...getDataAsPerRequirement(
          values.auditTypeCategoryId,
          auditTypeCategories,
          "auditTypeCategory"
        ),
        ...getDataAsPerRequirement(values.auditTypeId, auditTypes, "auditType"),
        ...getDataAsPerRequirement(values.branchId, branches, "branch"),
        ...getDataAsPerRequirement(
          values.departmentId,
          departments,
          "department"
        ),
        ...getDataAsPerRequirement(values.areaId, areas, "area"),
        startDate: addCurrentTimeInTimeStamp(values.startDate),
        endDate: addCurrentTimeInTimeStamp(values.endDate),
        totalActivitiesCount: values.totalActivitiesCount,
        totalNCActivitiesCount: values.totalNCActivitiesCount,
        closedActivitiesCount: values.closedActivitiesCount,
        auditReportURL: auditReportImageURL.file,
        auditorDetails: {
          auditorName: values.auditorName,
          organizationType: values.organizationType,
          department: values.department,
          companyName: values.companyName,
          contactNumber: values.contactNumber,
          email: values.email,
          employeeId: values.employeeId,
        },
        ncActivities: filteredNCActivity,
        accountId: accountId,
      };

      const isValidPayload = validateAuditPayload(payload);

      if (!params?.auditId && isCreateMode && isUser) {
        const create_payload = { ...payload, createdBy: userUid };
        // Proceed with form submission
        if (!isValidPayload?.length) {
          handleFinalSaveWarning(true, create_payload, "CREATE");
        } else {
          handleFinalSaveAfterDocumentUpload(
            create_payload,
            "CREATE"
          );
        }
      } else if (
        params?.auditId &&
        isUpdateMode &&
        userUid === thirdPartyAuditdataByLocalStorage?.createdBy
      ) {
        const update_payload = {
            ...payload,
            updatedBy: userUid,
            thirdPartyAuditId: params?.auditId,
          }
        if (!isValidPayload?.length) {
          handleFinalSaveWarning(true, update_payload, "UPDATE");
        } else {
          handleFinalSaveAfterDocumentUpload(
            update_payload,
            "UPDATE"
          );
        }
      } else {
        showSnackbar("Insufficient access to update audit details", SNACKBAR_VARIANT.ERROR)
      }

      // const errors = validateAuditPayload(payload);

      // if (errors.length > 0) {
      //   errors.forEach((err) => showSnackbar(err, SNACKBAR_VARIANT.ERROR)); // Show each error in UI
      //   return; // Block submit
      // }
    },
    onReset: () => {
      handleReset();
    },
  });

  // Destruct some required values
  const { branchId, departmentId, auditTypeCategoryId } = validation.values;

  const resetValidationField = (fieldName, Value) => {
    validation.setFieldValue(fieldName, Value);
    validation.setFieldTouched(fieldName, "");
  };

  const resetDataOnBranchSelection = () => {
    resetValidationField("departmentId", "");
    resetValidationField("areaId", "");
    setDepartments([]);
  };

  useEffect(() => {
    fetchAllAuditTypeCategories();
    fetchAllAuditTypes();
    fetchAllBranches();
  }, []);

  useEffect(() => {
    if (params?.auditId && thirdPartyAuditdataByLocalStorage) {
      const { branchId, departmentId, ncActivities, auditReportURL } =
        thirdPartyAuditdataByLocalStorage;
      if (branchId && departmentId) {
        fetchAllDepartmentByBranchId(branchId);
        fetchAllAreaByDepartmentIdAndBranchId(branchId, departmentId);
      }

      if (ncActivities && ncActivities[0]) {
        const formattedActivities = [...ncActivities].map((data) => {
          return {
            ...data,
            id: generateRandomId(15),
          };
        });
        setNCActivityDataTable(formattedActivities);
      }

      if (auditReportURL) {
        const fileName = getFileNameFromInput(auditReportURL);
        setAuditReportImageURL({
          name: fileName,
          url: auditReportURL,
          file: auditReportURL,
        });
      }
    }
  }, [params?.auditId, thirdPartyAuditdataByLocalStorage]);

  // Fetch areas when department changes (Only if branchId exists)
  useEffect(() => {
    if (!params.auditId) {
      if (departmentId && branchId) {
        fetchAllAreaByDepartmentIdAndBranchId(branchId, departmentId);
      } else {
        setAreas([]);
      }
    }
  }, [departmentId, branchId, params.auditId]);

  // Handle global loading state
  useEffect(() => {
    // Global loading state
    const isAllLoadingComplete = Object.values(loadingState).every(
      (status) => !status
    );

    if (!isAllLoadingComplete) {
      showBackdrop();
    } else {
      hideBackdrop();
    }
  }, [loadingState]);

  const disablePreviousDateForEndDate = (date) => {
    const selectedDate = dayjs(date).startOf("day");
    const minDate = dayjs(validation.values.startDate).startOf("day");
    return selectedDate.isBefore(minDate);
  };

  // Imp Conditions
  // const isBranchOrDeptSelected = branchId && departmentId ? true : false;
  const isAuditTypeCategorySelected = auditTypeCategoryId ? true : false;

  // Audit Status
  const isAuditStatusDraft =
    params?.auditId && thirdPartyAuditdataByLocalStorage?.status === draftAudits
      ? true
      : false;

  const isAuditStatusReviewPending =
    params?.auditId &&
    thirdPartyAuditdataByLocalStorage?.status === reviewPending
      ? true
      : false;

  const isAuditStatusCompleted =
    params?.auditId && thirdPartyAuditdataByLocalStorage?.status === completed
      ? true
      : false;

  // Function to change field value
  const handleChangeForFields = (event, fieldName, value) => {
    if (value) {
      const event_ = {
        ...event,
        target: {
          ...event?.target,
          name: fieldName,
          id: fieldName,
          value: value || "",
        },
      };
      validation.handleChange(event_);
    }
  };

  // Function to handle change in numeric fields
  const handleChangeInNumericField = (event) => {
    const { name, value } = event?.target || {};

    // Allow only numeric characters (including empty string to allow deletion)
    if (!/^\d*$/.test(value)) return;

    // Allow user to clear the field
    if (value === "") {
      validation.setFieldValue(name, "");
      return;
    }

    // Disallow values starting with 0 (except "0" by itself if you want)
    if (/^0\d+/.test(value) || value === "0") return;

    let parsedValue = Number(value);

    validation.setFieldValue(name, parsedValue);
  };

  // Function used to handle select audit report
  const handleChangeFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Create a blob URL
      const blobUrl = URL.createObjectURL(file);

      // Store file name and blob URL
      setAuditReportImageURL({ 
        name: file.name, 
        url: blobUrl,
        file: file 
      });
    }
  };

  // Function to filter audit types by category
  const filterAuditTypeByCategory = (Data, categoryId) => {
    if (!Data || !categoryId || Data.length === 0) return;

    const filteredAuditTypes = [...Data].filter(
      (auditType) => auditType.auditTypeCategoryId === categoryId
    );
    resetValidationField("auditTypeId", "");
    setRequiredDataForDropdown(setAuditTypes, filteredAuditTypes, "name", "id");
  };

  // Function to handle change in activity status table
  const handleChangeInNCActivityTable = (action, id = null, obj = {}) => {
    let updatedData = [...NCActivityDataTable];
    let randomId = generateRandomId(15);

    if (action === "UPDATE" && id) {
      updatedData = updatedData.map((item) =>
        item.id === id ? { ...item, ...obj } : item
      ); // Update a existing object
    } else if (action === "DELETE" && id) {
      updatedData = updatedData.filter((item) => item.id !== id);
    } else if (action === "ADD") {
      updatedData.push({ id: randomId, ...obj }); // Adds a new object
    }

    setNCActivityDataTable(updatedData);
  };

  const chipDetails = () => {
    const status = getStatusChipDetailsForThirdPartyAudits(
      !params?.auditId
        ? "New"
        : isAuditStatusDraft
        ? draftAudits
        : thirdPartyAuditdataByLocalStorage?.status
    );
    return status;
  };

  // Function to handle file view in new tab
  const viewBlobInNewTab = (fileBlob) => {
    window.open(fileBlob, "_blank");
  };

  // Function to Delete Audit Report
  const deleteAuditUrl = () => {
    setAuditReportImageURL({
      name: "",
      url: null,
      file: null
    });
  };

  // Function to check the user access for edit/update form
  const isFieldEditable = () => {
    if (isViewMode) return false;
    if (!isUser) return false;

    const isEditMode = isCreateMode || isUpdateMode;

    const isDraftStatus =
      isCreateMode || // assume it's editable in create
      thirdPartyAuditdataByLocalStorage?.status === draftAudits;

    // Check if current user is the creator (only relevant for update mode)
    const isAuditCreator =
      isCreateMode || thirdPartyAuditdataByLocalStorage?.createdBy === userUid;

    return isEditMode && isDraftStatus && isAuditCreator;
  };

  const handleAddActivity = () => {
    const ncActivityCount = validation.values.totalNCActivitiesCount;
    const maxCount = Number(ncActivityCount);

    if (!maxCount || isNaN(maxCount)) {
      showSnackbar(
        "Please enter a valid Total NC Activities Count before adding records.",
        SNACKBAR_VARIANT.ERROR
      );
      if (!accordionState.basicAuditDetails) {
        toggleAccordion("basicAuditDetails")
      }
      return;
    }

    if (NCActivityDataTable.length >= maxCount) {
      showSnackbar(
        `You can only add up to ${maxCount} NC activities.`,
        SNACKBAR_VARIANT.ERROR
      );
      return;
    }

    handleToggleNCActivityModal(null, true, "CREATE");
  };

  // Detect errors and scroll to top if there are any
  const hasErrorInFirstAccordion = () => {
    const {
      auditTypeCategoryId,
      auditTypeId,
      branchId,
      departmentId,
      areaId,
      startDate,
      endDate,
      totalActivitiesCount,
      totalNCActivitiesCount,
      closedActivitiesCount,
    } = validation.errors;

    const hasError =
      auditTypeCategoryId ||
      auditTypeId ||
      branchId ||
      departmentId ||
      areaId ||
      startDate ||
      endDate ||
      totalActivitiesCount ||
      totalNCActivitiesCount ||
      closedActivitiesCount;

    return hasError;
  };

  const hasErrorInSecondAccordion = () => {
    const {
      auditorName,
      companyName,
      contactNumber
    } = validation.errors;

    const hasError = auditorName || companyName || contactNumber;
    return hasError;
  };

  useEffect(() => {
    const hasErrors = Object.keys(validation.errors).length > 0;
    const newSubmission = validation.submitCount > lastSubmitCountRef.current;

    if (hasErrors && newSubmission) {
      lastSubmitCountRef.current = validation.submitCount;

      // Open relevant accordions and scroll to top
      if (hasErrorInFirstAccordion()) {
        if (!accordionState.basicAuditDetails) {
          toggleAccordion("basicAuditDetails");
        }
      }
      if (hasErrorInSecondAccordion()) {
        if (!accordionState.auditorDetails) {
          toggleAccordion("auditorDetails");
        }
      }

      window.scroll({ top: 0, behavior: "smooth" });
    }
  }, [validation.errors, validation.submitCount]);

  return (
    <React.Fragment>
      {finalSaveModalState?.isOpen && (
        <WarningModalForThirdPartyFinalSave
          Open={finalSaveModalState?.isOpen}
          ToggleFunction={handleFinalSaveWarning}
          Data={finalSaveModalState?.data}
          Type={finalSaveModalState?.type}
          OnSubmit={(data, type) => {
            if (type === "FINAL_SAVE") {
              updateThirdPartyAuditStatus(data);
            } else {
              handleFinalSaveAfterDocumentUpload(data, type);
            }
          }}
        />
      )}

      {sendBackToAuditeeModal?.isOpen && (
        <ThirdPartyRemarksAndReasonModal
          Open={sendBackToAuditeeModal?.isOpen}
          API_Payload={sendBackToAuditeeModal?.apiPayload}
          ToggleFunction={handleToggleOfSendBackToAditeeModal}
          OnSubmit={(data) => updateThirdPartyAuditStatus(data)}
        />
      )}

      <div
        className="page-content"
        style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        <Grid2 container className="mb-2" alignItems={"center"}>
          <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
            <div className="d-flex align-items-center gap-2 py-1">
              <Icons.KeyboardBackspaceIcon
                className="cursor-pointer"
                style={{ color: "GrayText" }}
                onClick={() => {
                  localStorage.removeItem(
                    process.env.REACT_APP_DEV_THIRD_PARTY_AUDIT_DATA
                  );
                  navigate(-1);
                }}
              />
              <Typography className="inter-medium-500">
                {!params?.auditId && isCreateMode
                  ? "Create Third Party Audit"
                  : params?.auditId && isViewMode
                  ? "View Third Party Audit"
                  : params?.auditId &&
                    isUpdateMode &&
                    "Update Third Party Audit"}
              </Typography>
            </div>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 8, md: 8, lg: 8 }}>
            <div className="d-flex flex-wrap align-items-center justify-content-sm-end justify-content-between w-100">
              {!isCreateMode && (
                <Typography className="inter-medium-500 me-2">
                  {`ID: ${thirdPartyAuditdataByLocalStorage?.auditId} | `}
                </Typography>
              )}
              {!isCreateMode && (
                <Typography className="inter-medium-500 me-2">
                  {`Created By: ${
                    thirdPartyAuditdataByLocalStorage?.createdByName ||
                    "Not Available"
                  } | `}
                </Typography>
              )}
              <Chip
                sx={{
                  borderRadius: "4px",
                  border: `1px solid ${chipDetails().textColor}`,
                  background: chipDetails().pillColor,
                  color: chipDetails().textColor,
                }}
                size="small"
                className="px-2"
                label={chipDetails().status}
              />
            </div>
          </Grid2>
        </Grid2>
        <Divider
          className="mb-1"
          style={{ color: "GrayText", border: "0.02rem solid GrayText" }}
        />

      {thirdPartyAuditdataByLocalStorage?.remark !==
        thirdPartyRemarkConfigData.notAvailable &&
        params?.auditId && (
          <Grid2 container spacing={2} className="my-1">
            <Grid2 size={12}>
              <div className="d-flex align-items-center flex-wrap w-100 gap-2">
                <Typography className="inter-medium-500">Remark:</Typography>
                <RemarkText
                  data={thirdPartyAuditdataByLocalStorage?.remark}
                  size="large"
                />
              </div>
              <div className="d-flex align-items-center flex-wrap w-100 gap-2 my-1">
                <Typography className="inter-regular-400" variant="body2">
                  {thirdPartyAuditdataByLocalStorage?.reason}
                </Typography>
              </div>
            </Grid2>
          </Grid2>
        )}

        {((!params?.auditId && isCreateMode) || (isUser && isUpdateMode)) && (
          <Grid2 container spacing={2}>
            <Grid2 size={12}>
              <div className="text-end">
                <Typography variant="caption">
                  {" "}
                  Need help? <ThirdPartyAuditInfo />
                </Typography>
              </div>
            </Grid2>
          </Grid2>
        )}

        {/* Basic Audit Details Section */}
        <div className="my-2">
          <Accordion
            expanded={accordionState.basicAuditDetails}
            onChange={() => toggleAccordion("basicAuditDetails")}
            style={accordionStyle}
            disableGutters
          >
            <AccordionSummary
              expandIcon={<Icons.ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              style={{
                ...accordionHeaderStyle,
                borderBottom: accordionState.basicAuditDetails
                  ? "2px solid rgba(93, 101, 108, 0.3)"
                  : "none",
              }}
            >
              <Typography className="inter-medium-500">
                Basic Audit Details
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Audit Type Category
                  </Typography>
                  <AppAutoCompleteField
                    IsMultiple={false}
                    TextInputName={"auditTypeCategoryId"}
                    TextInputId={"auditTypeCategoryId"}
                    Id={"auditTypeCategoryId"}
                    TextInputPlaceholder={"Select Audit Type Category"}
                    Options={auditTypeCategories || []}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.auditTypeCategoryId || ""}
                    HandleOnBlur={validation.handleBlur}
                    HandleOnChange={(event, value_) => {
                      handleChangeForFields(
                        event,
                        "auditTypeCategoryId",
                        value_?.value
                      );
                      if (value_?.value)
                        filterAuditTypeByCategory(allAuditTypes, value_?.value);
                    }}
                    TextInputError={
                      validation.touched.auditTypeCategoryId &&
                      validation.errors.auditTypeCategoryId
                        ? true
                        : false
                    }
                    TextInputHelperText={
                      validation.touched.auditTypeCategoryId &&
                      validation.errors.auditTypeCategoryId
                        ? validation.errors.auditTypeCategoryId
                        : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Audit Type
                  </Typography>
                  <AppAutoCompleteField
                    IsMultiple={false}
                    TextInputName={"auditTypeId"}
                    TextInputId={"auditTypeId"}
                    Id={"auditTypeId"}
                    TextInputPlaceholder={"Select Audit Type"}
                    Options={auditTypes || []}
                    Disabled={
                      !isAuditTypeCategorySelected || !isFieldEditable()
                    }
                    Value={validation.values.auditTypeId || ""}
                    HandleOnBlur={validation.handleBlur}
                    HandleOnChange={(event, value_) => {
                      handleChangeForFields(
                        event,
                        "auditTypeId",
                        value_?.value
                      );
                    }}
                    TextInputError={
                      validation.touched.auditTypeId &&
                      validation.errors.auditTypeId
                        ? true
                        : false
                    }
                    TextInputHelperText={
                      validation.touched.auditTypeId &&
                      validation.errors.auditTypeId
                        ? validation.errors.auditTypeId
                        : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Branch
                  </Typography>
                  <AppAutoCompleteField
                    IsMultiple={false}
                    TextInputName={"branchId"}
                    TextInputId={"branchId"}
                    Id={"branchId"}
                    TextInputPlaceholder={"Select Branch"}
                    Options={branches || []}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.branchId || ""}
                    HandleOnBlur={validation.handleBlur}
                    HandleOnChange={(event, value_) => {
                      handleChangeForFields(
                        event,
                        "branchId",
                        value_?.value || ""
                      );
                      if (value_?.value) {
                        resetDataOnBranchSelection();
                        if (isCreateMode && !params.auditId) {
                          fetchAllDepartmentByBranchId(value_?.value);
                        }
                      }
                    }}
                    TextInputError={
                      validation.touched.branchId && validation.errors.branchId
                        ? true
                        : false
                    }
                    TextInputHelperText={
                      validation.touched.branchId && validation.errors.branchId
                        ? validation.errors.branchId
                        : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Department
                  </Typography>
                  <AppAutoCompleteField
                    IsMultiple={false}
                    TextInputName={"departmentId"}
                    TextInputId={"departmentId"}
                    Id={"departmentId"}
                    TextInputPlaceholder={"Select Department"}
                    Options={departments || []}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.departmentId || ""}
                    HandleOnBlur={validation.handleBlur}
                    HandleOnChange={(event, value_) => {
                      handleChangeForFields(
                        event,
                        "departmentId",
                        value_?.value || ""
                      );
                      if (value_?.value) {
                        resetValidationField("areaId", "");
                        setAreas([]);
                      }
                    }}
                    TextInputError={
                      validation.touched.departmentId &&
                      validation.errors.departmentId
                        ? true
                        : false
                    }
                    TextInputHelperText={
                      validation.touched.departmentId &&
                      validation.errors.departmentId
                        ? validation.errors.departmentId
                        : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Area
                  </Typography>
                  <AppAutoCompleteField
                    IsMultiple={false}
                    TextInputName={"areaId"}
                    TextInputId={"areaId"}
                    Id={"areaId"}
                    TextInputPlaceholder={"Select Area"}
                    Options={areas || []}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.areaId || ""}
                    HandleOnBlur={validation.handleBlur}
                    HandleOnChange={(event, value_) => {
                      handleChangeForFields(
                        event,
                        "areaId",
                        value_?.value || ""
                      );
                    }}
                    TextInputError={
                      validation.touched.areaId && validation.errors.areaId
                        ? true
                        : false
                    }
                    TextInputHelperText={
                      validation.touched.areaId && validation.errors.areaId
                        ? validation.errors.areaId
                        : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Start Date
                  </Typography>
                  <MUIDatePicker
                    Name={"startDate"}
                    Id={"startDate"}
                    EnablePast={true}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.startDate || ""}
                    OnBlur={validation.handleBlur}
                    OnChange={validation.handleChange}
                    PlaceHolder={"DD/MM/YYYY"}
                    Error={
                      validation.touched.startDate &&
                      validation.errors.startDate
                        ? true
                        : false
                    }
                    HelperText={
                      validation.touched.startDate &&
                      validation.errors.startDate ? (
                        <MUIErrorText
                          ErrorMessage={validation.errors.startDate}
                        />
                      ) : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    End Date
                  </Typography>
                  <MUIDatePicker
                    Name={"endDate"}
                    Id={"endDate"}
                    EnablePast={true}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.endDate || ""}
                    OnBlur={validation.handleBlur}
                    OnChange={validation.handleChange}
                    ShouldDisableCurrentDate={disablePreviousDateForEndDate}
                    PlaceHolder={"DD/MM/YYYY"}
                    Error={
                      validation.touched.endDate && validation.errors.endDate
                        ? true
                        : false
                    }
                    HelperText={
                      validation.touched.endDate &&
                      validation.errors.endDate ? (
                        <MUIErrorText
                          ErrorMessage={validation.errors.endDate}
                        />
                      ) : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Total Activities Count
                  </Typography>
                  <AppInputField
                    Name={"totalActivitiesCount"}
                    Id={"totalActivitiesCount"}
                    PlaceHolder={"Enter total activities count"}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.totalActivitiesCount || ""}
                    OnChange={handleChangeInNumericField}
                    OnBlur={validation.handleBlur}
                    Error={
                      validation.touched.totalActivitiesCount &&
                      validation.errors.totalActivitiesCount
                        ? true
                        : false
                    }
                    HelperText={
                      validation.touched.totalActivitiesCount &&
                      validation.errors.totalActivitiesCount
                        ? validation.errors.totalActivitiesCount
                        : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Total NC Activities Count
                  </Typography>
                  <AppInputField
                    Name={"totalNCActivitiesCount"}
                    Id={"totalNCActivitiesCount"}
                    PlaceHolder={"Enter NC activities count"}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.totalNCActivitiesCount || ""}
                    OnChange={handleChangeInNumericField}
                    OnBlur={validation.handleBlur}
                    Error={
                      validation.touched.totalNCActivitiesCount &&
                      validation.errors.totalNCActivitiesCount
                        ? true
                        : false
                    }
                    HelperText={
                      validation.touched.totalNCActivitiesCount &&
                      validation.errors.totalNCActivitiesCount
                        ? validation.errors.totalNCActivitiesCount
                        : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Closed Activities Count
                  </Typography>
                  <AppInputField
                    Name={"closedActivitiesCount"}
                    Id={"closedActivitiesCount"}
                    PlaceHolder={"Enter closed activities count"}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.closedActivitiesCount || ""}
                    OnChange={handleChangeInNumericField}
                    OnBlur={validation.handleBlur}
                    Error={
                      validation.touched.closedActivitiesCount &&
                      validation.errors.closedActivitiesCount
                        ? true
                        : false
                    }
                    HelperText={
                      validation.touched.closedActivitiesCount &&
                      validation.errors.closedActivitiesCount
                        ? validation.errors.closedActivitiesCount
                        : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Upload Audit Report
                  </Typography>
                  <div className="mt-2">
                    <input
                      type="file"
                      id="audit-report-file"
                      name=""
                      accept="image/png, image/jpg, image/jpeg, application/pdf, .docx"
                      style={{ display: "none" }}
                      onChange={handleChangeFile}
                    />
                    <div className="d-flex align-items-center gap-2">
                      <Link
                        to="#"
                        onClick={() => {
                          if (!auditReportImageURL?.url) {
                            var inputFile =
                              document.querySelector("#audit-report-file");
                            inputFile.click();
                          }
                        }}
                        className="inter-regular-400"
                        style={{
                          fontSize: "14px",
                          color: AppTheme.PRIMARY_COLOR,
                          display: "inline-block",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {auditReportImageURL?.name || "Choose New File"}
                      </Link>

                      {auditReportImageURL?.url && (
                        <img
                          src={ViewIcon}
                          className="cursor-pointer"
                          alt={"View"}
                          onClick={() =>
                            viewBlobInNewTab(auditReportImageURL?.url)
                          }
                          style={{ width: "20px", height: "20px" }}
                        />
                      )}
                      {auditReportImageURL?.url &&
                        (isCreateMode || isUpdateMode) &&
                        (isCreateMode ||
                          thirdPartyAuditdataByLocalStorage?.status ===
                            draftAudits) &&
                        isUser && (
                          <img
                            src={DeleteIcon}
                            className="cursor-pointer"
                            alt={"Delete"}
                            onClick={deleteAuditUrl}
                            style={{
                              width: "20px",
                              height: "20px",
                            }}
                          />
                        )}
                    </div>
                  </div>
                </Grid2>
              </Grid2>
            </AccordionDetails>
          </Accordion>
        </div>

        {/* Auditor Details Section */}
        <div className="my-2">
          <Accordion
            expanded={accordionState.auditorDetails}
            onChange={() => toggleAccordion("auditorDetails")}
            style={accordionStyle}
            disableGutters
          >
            <AccordionSummary
              expandIcon={<Icons.ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              style={{
                ...accordionHeaderStyle,
                borderBottom: accordionState.auditorDetails
                  ? "2px solid rgba(93, 101, 108, 0.3)"
                  : "none",
              }}
            >
              <Typography className="inter-medium-500">
                Auditor Details
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Auditor Name <span className="mandatory-field">*</span>
                  </Typography>
                  <AppInputField
                    Name={"auditorName"}
                    Id={"auditorName"}
                    PlaceHolder={"Enter auditor name"}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.auditorName || ""}
                    OnBlur={validation.handleBlur}
                    OnChange={validation.handleChange}
                    Error={
                      validation.touched.auditorName &&
                      validation.errors.auditorName
                        ? true
                        : false
                    }
                    HelperText={
                      validation.touched.auditorName &&
                      validation.errors.auditorName
                        ? validation.errors.auditorName
                        : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Organization Type
                  </Typography>
                  <AppInputField
                    Name={"organizationType"}
                    Id={"organizationType"}
                    PlaceHolder={"Enter organization type"}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.organizationType || ""}
                    OnBlur={validation.handleBlur}
                    OnChange={validation.handleChange}
                    Error={
                      validation.touched.organizationType &&
                      validation.errors.organizationType
                        ? true
                        : false
                    }
                    HelperText={
                      validation.touched.organizationType &&
                      validation.errors.organizationType
                        ? validation.errors.organizationType
                        : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Department
                  </Typography>
                  <AppInputField
                    Name={"department"}
                    Id={"department"}
                    PlaceHolder={"Enter department"}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.department || ""}
                    OnBlur={validation.handleBlur}
                    OnChange={validation.handleChange}
                    Error={
                      validation.touched.department &&
                      validation.errors.department
                        ? true
                        : false
                    }
                    HelperText={
                      validation.touched.department &&
                      validation.errors.department
                        ? validation.errors.department
                        : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Company Name <span className="mandatory-field">*</span>
                  </Typography>
                  <AppInputField
                    Name={"companyName"}
                    Id={"companyName"}
                    PlaceHolder={"Enter company name"}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.companyName || ""}
                    OnBlur={validation.handleBlur}
                    OnChange={validation.handleChange}
                    Error={
                      validation.touched.companyName &&
                      validation.errors.companyName
                        ? true
                        : false
                    }
                    HelperText={
                      validation.touched.companyName &&
                      validation.errors.companyName
                        ? validation.errors.companyName
                        : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Contact Number <span className="mandatory-field">*</span>
                  </Typography>
                  <AppInputField
                    Name={"contactNumber"}
                    Id={"contactNumber"}
                    PlaceHolder={"Enter contact number"}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.contactNumber || ""}
                    OnBlur={validation.handleBlur}
                    OnChange={validation.handleChange}
                    Error={
                      validation.touched.contactNumber &&
                      validation.errors.contactNumber
                        ? true
                        : false
                    }
                    HelperText={
                      validation.touched.contactNumber &&
                      validation.errors.contactNumber
                        ? validation.errors.contactNumber
                        : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Email
                  </Typography>
                  <AppInputField
                    Name={"email"}
                    Id={"email"}
                    PlaceHolder={"Enter email"}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.email || ""}
                    OnBlur={validation.handleBlur}
                    OnChange={validation.handleChange}
                    Error={
                      validation.touched.email && validation.errors.email
                        ? true
                        : false
                    }
                    HelperText={
                      validation.touched.email && validation.errors.email
                        ? validation.errors.email
                        : null
                    }
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-1"
                  >
                    Employee Id
                  </Typography>
                  <AppInputField
                    Name={"employeeId"}
                    Id={"employeeId"}
                    PlaceHolder={"Enter employee id"}
                    Disabled={!isFieldEditable()}
                    Value={validation.values.employeeId || ""}
                    OnBlur={validation.handleBlur}
                    OnChange={validation.handleChange}
                    Error={
                      validation.touched.employeeId &&
                      validation.errors.employeeId
                        ? true
                        : false
                    }
                    HelperText={
                      validation.touched.employeeId &&
                      validation.errors.employeeId
                        ? validation.errors.employeeId
                        : null
                    }
                  />
                </Grid2>
              </Grid2>
            </AccordionDetails>
          </Accordion>
        </div>

        <div className="my-2">
          <Grid2 container spacing={2} alignItems={"center"}>
            <Grid2 size={{ xs: 6, sm: 9, md: 9, lg: 10 }}>
              <Typography className="inter-medium-500">
                NC Activities
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 6, sm: 3, md: 3, lg: 2 }}>
              <div className="d-flex flex-wrap align-items-center justify-content-end w-100">
                <AppButton
                  OnPress={handleAddActivity}
                  IsDisabled={!isFieldEditable()}
                >
                  Add New NC Point
                </AppButton>
              </div>
            </Grid2>
            <Grid2 size={12}>
              <DataTableToUpdateNCActivityOfThirdPartyAudit
                Columns={dataTableColumnsForNCActivitiesOfThirdPartyAudits}
                RowData={NCActivityDataTable || []}
                DenseTable={true}
                RowsToDisplay={10}
                OptionsForRowsPerPage={[5, 10, 15, 25, 50]}
                NCActivityModalState={addOrUpdateNCActivityModal}
                HandleChangeInNCActivityTable={(Action, Id, Obj) => {
                  handleChangeInNCActivityTable(Action, Id, Obj);
                }}
                HandleToggleNCActivityModal={(Data, IsOpen, Type) => {
                  handleToggleNCActivityModal(Data, IsOpen, Type);
                }}
                IsViewMode={isViewMode}
                IsAuditStatusCompleted={isAuditStatusCompleted}
                IsAuditStatusDraft={
                  isCreateMode ||
                  thirdPartyAuditdataByLocalStorage?.status === draftAudits
                }
                IsAuditStatusReviewPending={isAuditStatusReviewPending}
              />
            </Grid2>
          </Grid2>
        </div>

        <div
          style={{
            display: "flex",
            marginTop: "auto",
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Grid2 container spacing={2} className="mt-2 pb-3 w-100">
            {!params.auditId && (
              <Grid2 size={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
                <AppButton
                  Type={"reset"}
                  OnPress={() => {
                    validation.handleReset();
                  }}
                  children={"Reset"}
                  Color={"error"}
                />
              </Grid2>
            )}

            {params?.auditId &&
              isAuditStatusReviewPending &&
              (isSuperAdmin || isAdmin) && (
                <Grid2 size={6}>
                  <AppButton
                    Type={"button"}
                    Color={"error"}
                    OnPress={() => {
                      if (navigator.onLine) {
                        const payload = {
                          thirdPartyAuditId: params?.auditId,
                          accountId: accountId,
                          updatedBy: userUid,
                          status: draftAudits,
                        };
                        handleToggleOfSendBackToAditeeModal(true, payload);
                      } else {
                        showSnackbar(
                          ERROR_MESSAGE.INTERNET_ERROR,
                          SNACKBAR_VARIANT.ERROR
                        );
                      }
                    }}
                    children={"Send Back To Auditee"}
                  />
                </Grid2>
              )}

            {params?.auditId &&
              isAuditStatusReviewPending &&
              (isSuperAdmin || isAdmin) && (
                <Grid2 size={6}>
                  <AppButton
                    Type={"button"}
                    OnPress={() => {
                      if (navigator.onLine) {
                        const payload = {
                          thirdPartyAuditId: params?.auditId,
                          accountId: accountId,
                          updatedBy: userUid,
                          status: completed,
                          reason: "",
                          remark: "Success",
                        };
                        handleFinalSaveWarning(true, payload, "FINAL_SAVE");
                      } else {
                        showSnackbar(
                          ERROR_MESSAGE.INTERNET_ERROR,
                          SNACKBAR_VARIANT.ERROR
                        );
                      }
                    }}
                    children={"Mark As Completed"}
                  />
                </Grid2>
              )}

            {(isAuditStatusDraft || !params?.auditId) && isUser && (
              <Grid2 size={params.auditId ? 12 : 6}>
                <AppButton
                  Type={"submit"}
                  IsDisabled={!isFieldEditable()}
                  OnPress={() => {
                    if (navigator.onLine) {
                      validation.handleSubmit();
                    } else {
                      showSnackbar(
                        ERROR_MESSAGE.INTERNET_ERROR,
                        SNACKBAR_VARIANT.ERROR
                      );
                    }
                  }}
                  children={params.auditId ? "Update" : "Create"}
                />
              </Grid2>
            )}
          </Grid2>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateNewOrUpdateThirdPartyAudit;
